import update from 'react/lib/update';

const initialState = {
	isFetching: false,
	list: []
};

export default function groups(state = initialState, action) {
	
	switch (action.type) {			

		case "IS_FETCHING":
			return update(state, { isFetching: { $set: action.bool } });

		case "SET_GROUPS_LIST":
			return update(state, { list: { $set: action.groups } });		

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/state/domains/groups/reducer.js